module.exports = __webpack_public_path__ + "img/avatar3.aae498c9.png";